import React, { useContext } from 'react';
import classes from './OpmlImportModal.module.scss';
import { Modal } from '../../../../components/containers/Modal';
import { DropZone } from '../../../../components/actions/DropZone';
import { Button } from '../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { useDropzone } from 'react-dropzone';
import { MaxLimits } from '../../../../constants/media';
import { showToast } from '../../../../helpers/showToast';
import classNames from 'classnames';
import { getAllowedFilesExtensions } from 'helpers/fileUploadHelpers';

import { AdvancedFeature } from 'components/containers/AdvancedFeature';
import { AdvancedFeatures } from 'components/containers/AdvancedFeature/AdvancedFeature.view';
import { useOrganizationPlan } from 'hooks/useOrganizationPlan';
import { PlanImporterType } from 'models/graphql';
import { BeaconContext } from 'providers/BeaconProvider';

export type OpmlImportModalViewProps = {
  closeHandler: (show: boolean) => void;
  uploadLoading: boolean;
  uploadOpmlFile: (file: File) => void;
};

export const OpmlImportModalView = (props: OpmlImportModalViewProps): JSX.Element => {
  const { closeHandler, uploadOpmlFile } = props;
  const { importType, isTrial } = useOrganizationPlan();
  const isDisabled = importType !== PlanImporterType.ADVANCED_IMPORTER;
  const onDropRejectedHandler = (e: unknown[]) => {
    let summaryTxt = 'Invalid file extension';
    let detailTxt = (
      <>
        The file you&apos;re trying to upload doesn&apos;t have a valid extension. Valid file extensions are:
        <p>{getAllowedFilesExtensions()}</p>
      </>
    );

    if (e.length > MaxLimits.UPLOAD) {
      summaryTxt = 'Too many files to upload';
      detailTxt = <>Only 1 can be uploaded at one time.</>;
    }

    showToast({
      severity: 'error',
      summary: summaryTxt,
      detail: detailTxt
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    noClick: false,
    noKeyboard: true,
    accept: { 'text/xml': ['.opml'], 'application/xml': ['.opml'] },
    onDropRejected: onDropRejectedHandler,
    onDropAccepted: (files: File[]) => uploadOpmlFile(files[0]),
    disabled: isDisabled
  });

  const dropZoneWrapperClasses = classNames('margin-top-small-32', classes.DropZoneWrapper);
  const { beacon } = useContext(BeaconContext);
  return (
    <Modal size={'large'} title={'Import Feedly bookmarks'} onClose={closeHandler}>
      {(isDisabled || isTrial) && <AdvancedFeature feature={AdvancedFeatures.OPML} />}
      <div>
        Uploading an OPML file from Feedly will add your Feedly bookmarks to SmarterQueue as Saved Feeds.{' '}
        <a onClick={() => beacon('article', '707', { type: 'modal' })}>Learn more</a>.
      </div>
      <div className={dropZoneWrapperClasses}>
        <DropZone
          disabled={isDisabled}
          acceptedTypes={{ 'text/xml': [] }}
          maxFiles={1}
          onDropRejectedHandler={onDropRejectedHandler}
          onDropAcceptedHandler={(files: File[]) => uploadOpmlFile(files[0])}>
          <div className={classes.DropAreaContainer}>
            <div {...getRootProps()}>
              <input {...getInputProps()} disabled={isDisabled} />
              <Button
                disabled={isDisabled}
                type={'button'}
                variant={'solid'}
                size={'medium'}
                color={ButtonColorsEnum.primary}>
                Upload OPML file
              </Button>
            </div>
          </div>
        </DropZone>
      </div>
    </Modal>
  );
};
